import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/layout/Layout.vue'

Vue.use(VueRouter)

// 常量路由（无需权限）
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    meta: { title: '首页', icon: 'el-icon-s-home' },
    children: [
      {
        path: '',
        redirect: '/admin/list',
        hidden: true
      },
      {
        path: 'profile',
        component: () => import('@/views/profile/index.vue'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'el-icon-user' },
        hidden: true
      }
    ]
  },
  {
    path: '/admin',
    component: Layout,
    name: 'AdminManage',
    meta: { title: '管理员管理', icon: 'el-icon-s-custom' },
    children: [
      {
        path: 'list',
        component: () => import('@/views/admin/list.vue'),
        name: 'AdminList',
        meta: { title: '管理员列表', icon: 'el-icon-s-unfold' }
      },
      {
        path: 'edit/:id?',
        component: () => import('@/views/admin/edit.vue'),
        name: 'AdminEdit',
        meta: { title: '编辑管理员', noCache: true, activeMenu: '/admin/list' },
        hidden: true
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    name: 'UserManage',
    meta: { title: '用户管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'list',
        component: () => import('@/views/user/list.vue'),
        name: 'UserList',
        meta: { title: '用户列表', icon: 'el-icon-s-unfold' }
      }
    ]
  },
  {
    path: '/miniprogram',
    component: Layout,
    name: 'MiniprogramManage',
    meta: { title: '小程序管理', icon: 'el-icon-setting' },
    children: [
      {
        path: 'list',
        component: () => import('@/views/miniprogram/list.vue'),
        name: 'MiniprogramList',
        meta: { title: '小程序配置', icon: 'el-icon-s-unfold' }
      }
    ]
  },
  {
    path: '/gift',
    component: Layout,
    name: 'GiftManage',
    meta: { title: '积分兑换管理', icon: 'el-icon-present' },
    children: [
      {
        path: 'list',
        component: () => import('@/views/gift/list.vue'),
        name: 'GiftList',
        meta: { title: '道具列表', icon: 'el-icon-s-unfold' }
      }
    ]
  },
  {
    path: '/h5manage',
    component: Layout,
    name: 'H5Manage',
    meta: { title: 'H5管理', icon: 'el-icon-mobile-phone' },
    children: [
      {
        path: 'gift',
        component: () => import('@/views/h5manage/gift.vue'),
        name: 'H5GiftList',
        meta: { title: '礼品管理', icon: 'el-icon-present' }
      },
      {
        path: 'address',
        component: () => import('@/views/h5manage/address.vue'),
        name: 'H5AddressList',
        meta: { title: '用户地址管理', icon: 'el-icon-location' }
      },
      {
        path: 'order',
        component: () => import('@/views/h5manage/order.vue'),
        name: 'H5OrderList',
        meta: { title: '订单管理', icon: 'el-icon-s-order' }
      },
      {
        path: 'stats',
        component: () => import('@/views/h5manage/stats.vue'),
        name: 'H5Stats',
        meta: { title: '数据统计', icon: 'el-icon-data-line' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

// 解决路由重复跳转警告
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const token = store.state.user.token

  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      const hasInfo = store.state.user.info
      if (!hasInfo) {
        try {
          await store.dispatch('user/getInfo')
          next({ ...to, replace: true })
        } catch (error) {
          await store.dispatch('user/logout')
          next('/login?redirect=' + to.path)
        }
      } else {
        next()
      }
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login?redirect=' + to.path)
    }
  }
})

export default router
